import { Component } from 'react';
import {Link} from 'react-router-dom';

class OverviewRadarVideoComponent extends Component {
  render() {
    return (
      <div className="overview-radar">
        <div className="row radar-body">
          <div className="thumbnail">
            <img alt="Radar" src="/images/radar-thumbnail.jpeg"/>
          </div>
          <p>
            In de uitzending van Radar van 20 november 2017 heeft Jeroen Oversteegen van De Nationale Hypotheekbond
            vragen beantwoord over hoe banken omgaan met risico opslagen. Daarbij heeft hij voor informatie ook verwezen
            naar looptijdrente.nl en het belang van looptijdrente benoemd.&nbsp;
            <Link to="/radar">
              Bekijk de video
            </Link>
          </p>
        </div>
      </div>
    );
  }
}

export default OverviewRadarVideoComponent;